export const APPS_SCRIPT_URL = "https://script.google.com/macros/s/AKfycbwtLbEHu5eGEARGiNyUHwl3fz-e6-TP4moUHGvaWRSREkA2tiHyXiKnZUph9BHi5SvCDQ/exec"